import styled from 'styled-components';

import Placeholder from '@assets/images/promotions/promo_placeholder.webp';

export const Wrapper = styled.div<{ $bg?: string | null }>`
	height: 174px;
	padding: 16px;
	border-radius: 12px;
	position: relative;
	overflow: hidden;

	background-image: url(${({ $bg }) => ($bg ? $bg : Placeholder)});

	background-position: right;
	background-repeat: no-repeat;
	background-size: cover;

	&:after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
		background-color: rgba(0, 0, 0, 0.38);
	}
`;

export const Content = styled.div`
	height: 100%;
	position: relative;
	z-index: 20;
`;

export const Title = styled.h3`
	height: 50px;
	font-size: 18px;
	line-height: 25px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 16px;

	overflow: hidden;
	text-overflow: ellipsis;
`;

export const EndDate = styled.p`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-bottom: 16px;
`;
